import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getContentBlockerNodes, transformToOriginalContentBlockerAttribute, putScriptInlineToDom, createContentBlocker } from ".";
import { unmountComponentAtNode } from "react-dom";
import { OPT_IN_CONTENT_BLOCKER_ALL } from "../../types";
import { OPT_IN_CONTENT_BLOCKER } from "../../types";
import { applyJQueryInitiator, applyNativeEventListener, applyJQueryEvent, applyWindowOnload, customUnblockTriggers } from "..";
import { probablyResetParentContainerForContentBlocker, applyContentBlockerStyleRule, HTML_ATTRIBUTE_COOKIE_IDS, HTML_ATTRIBUTE_BLOCKER_CONNECTED, HTML_ATTRIBUTE_INLINE, HTML_ATTRIBUTE_UNBLOCKED_TRANSACTION_COMPLETE } from ".";
import { BLOCKER_LAST_CLICKED_CONNECTED_COUNTER } from "../../components";
var currentlyInTransaction = false;
/**
 * Refresh the DOM content depending on accepted cookies. It covers the following things:
 *
 * - Get all available blocked content
 * - Unblock blocked content depending on the passed accepted cookies
 * - All other blocked content gets a visual content-blocker (if possible)
 */

function manipulateContentBlockerDOM(_x) {
  return _manipulateContentBlockerDOM.apply(this, arguments);
}
/**
 * Check if the current page is currently unblocking content.
 */


function _manipulateContentBlockerDOM() {
  _manipulateContentBlockerDOM = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cookies) {
    var foundAnyLastClicked, nodes, unblockedNodes, _iterator, _step, row, consent, node, blocker, connectedBlocker, isLastClicked, contentBlockers, _iterator2, _step2, contentBlocker, ownerDocument, defaultView, _yield$transformToOri, performedClick;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            currentlyInTransaction = true;
            foundAnyLastClicked = false;
            nodes = getContentBlockerNodes(cookies);
            applyContentBlockerStyleRule(cookies); // A collection of all unblocked content for this "transaction"; so we can keep track a batch
            // of unblocked items to keep dependencies intact (e.g. Custom script is blocked and needs Google Maps
            // API do be available).

            unblockedNodes = [];
            _iterator = _createForOfIteratorHelper(nodes);
            _context.prev = 6;

            _iterator.s();

          case 8:
            if ((_step = _iterator.n()).done) {
              _context.next = 49;
              break;
            }

            row = _step.value;
            consent = row.consent, node = row.node, blocker = row.blocker;

            if (!consent) {
              _context.next = 46;
              break;
            }

            if (node.hasAttribute(HTML_ATTRIBUTE_COOKIE_IDS)) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("continue", 47);

          case 14:
            // Immediate deactivate nodes for future unblocks
            node.removeAttribute(HTML_ATTRIBUTE_COOKIE_IDS); // Remove visual content blocker if given

            connectedBlocker = node.getAttribute(HTML_ATTRIBUTE_BLOCKER_CONNECTED);
            isLastClicked = "".concat(BLOCKER_LAST_CLICKED_CONNECTED_COUNTER.count) === connectedBlocker;

            if (isLastClicked) {
              foundAnyLastClicked = true;
            }

            if (connectedBlocker) {
              contentBlockers = Array.prototype.slice.call(document.querySelectorAll(".rcb-content-blocker[consent-blocker-connected=\"".concat(connectedBlocker, "\"]")));
              _iterator2 = _createForOfIteratorHelper(contentBlockers);

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  contentBlocker = _step2.value;
                  unmountComponentAtNode(contentBlocker);
                  probablyResetParentContainerForContentBlocker(contentBlocker, false);
                  contentBlocker.remove();
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            } // Overwrite global listeners so they get immediate executed


            ownerDocument = node.ownerDocument;
            defaultView = ownerDocument.defaultView;
            applyJQueryInitiator(ownerDocument);
            applyJQueryEvent(ownerDocument, defaultView, "load"); // $(window).load()

            applyNativeEventListener(defaultView, "load");
            applyNativeEventListener(ownerDocument, "DOMContentLoaded");
            applyWindowOnload(ownerDocument); // [Plugin comp]

            applyJQueryEvent(ownerDocument, defaultView, "elementor/frontend/init");
            applyJQueryEvent(ownerDocument, defaultView, "tcb_after_dom_ready"); // Thrive Architect

            applyJQueryEvent(ownerDocument, ownerDocument, "tve-dash.load", {
              // Mark requests as already sent as blocked modules in Thrive never gets loaded again
              onBeforeExecute: function onBeforeExecute() {
                var _ref2 = window,
                    TVE_Dash = _ref2.TVE_Dash;
                TVE_Dash.ajax_sent = true;
              }
            }); // Thrive Leads
            // Activate node

            if (!node.hasAttribute(HTML_ATTRIBUTE_INLINE)) {
              _context.next = 36;
              break;
            }

            _context.next = 32;
            return transformToOriginalContentBlockerAttribute(node, false, true);

          case 32:
            _context.next = 34;
            return putScriptInlineToDom(node);

          case 34:
            _context.next = 41;
            break;

          case 36:
            _context.next = 38;
            return transformToOriginalContentBlockerAttribute(node, isLastClicked);

          case 38:
            _yield$transformToOri = _context.sent;
            performedClick = _yield$transformToOri.performedClick;

            if (performedClick) {
              // Avoid auto replays between the same transaction
              BLOCKER_LAST_CLICKED_CONNECTED_COUNTER.count = undefined;
            }

          case 41:
            node.dispatchEvent(new CustomEvent(OPT_IN_CONTENT_BLOCKER, {
              detail: {
                blocker: blocker,
                gotClicked: isLastClicked
              }
            }));
            document.dispatchEvent(new CustomEvent(OPT_IN_CONTENT_BLOCKER, {
              detail: {
                blocker: blocker,
                element: node,
                gotClicked: isLastClicked
              }
            }));
            unblockedNodes.push(row);
            _context.next = 47;
            break;

          case 46:
            createContentBlocker(row);

          case 47:
            _context.next = 8;
            break;

          case 49:
            _context.next = 54;
            break;

          case 51:
            _context.prev = 51;
            _context.t0 = _context["catch"](6);

            _iterator.e(_context.t0);

          case 54:
            _context.prev = 54;

            _iterator.f();

            return _context.finish(54);

          case 57:
            // This transaction is "complete"
            if (unblockedNodes.length) {
              // Definitely reset now our last clicked counter to avoid double auto plays
              if (foundAnyLastClicked) {
                BLOCKER_LAST_CLICKED_CONNECTED_COUNTER.count = undefined;
              } // Do this before the events below to keep the initiators intact (e.g. jQuery.fn.ready)


              currentlyInTransaction = false;
              document.dispatchEvent(new CustomEvent(OPT_IN_CONTENT_BLOCKER_ALL, {
                detail: {
                  unblockedNodes: unblockedNodes
                }
              }));
              unblockedNodes.forEach(function (_ref) {
                var node = _ref.node;
                node.setAttribute(HTML_ATTRIBUTE_UNBLOCKED_TRANSACTION_COMPLETE, "1");
                node.dispatchEvent(new CustomEvent(OPT_IN_CONTENT_BLOCKER_ALL, {
                  detail: {
                    unblockedNodes: unblockedNodes
                  }
                }));
              }); // The initiators (e.g. jQuery.ready) are all loaded in a new "thread" with a `setTimeout`,
              // but we need to make sure this event is dispatched afterwards.

              setTimeout(function () {
                customUnblockTriggers(unblockedNodes);
              }, 0);
            } else {
              currentlyInTransaction = false;
            }

          case 58:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 51, 54, 57]]);
  }));
  return _manipulateContentBlockerDOM.apply(this, arguments);
}

function isCurrentlyInTransaction() {
  return currentlyInTransaction;
}

export { manipulateContentBlockerDOM, isCurrentlyInTransaction };